import {
	PrepopulatedCredentials,
	WorkspaceConfiguration,
} from '@citrite/workspace-ui-platform';
import $ from 'jquery';
import { FormActions } from './formActions';
import { RequirementNodeProcessor } from './requirementNodesProcessor';

export function generateLoginFormFromXml(
	xmlData: Element,
	prePopulatedCredentials: PrepopulatedCredentials,
	workspaceConfiguration: WorkspaceConfiguration
) {
	const form = $("<form class='form insertPoint' action='' />");
	const requirementsNodes = getRequirementsNodes(xmlData);

	RequirementNodeProcessor.addFieldsForEachRequirement(
		requirementsNodes,
		form,
		xmlData,
		workspaceConfiguration
	);
	highlightFieldsThatNeedHighlightingAndTagInputs(requirementsNodes, form);
	FormActions.populateForm(form, prePopulatedCredentials);

	return form;
}

function getRequirementsNodes(xmlData: Element) {
	return $('Requirement', xmlData);
}

function highlightFieldsThatNeedHighlightingAndTagInputs(
	requirementsNodes: JQuery,
	form: JQuery
) {
	requirementsNodes.each(function (this: Element) {
		const requirementsXmlNode = this;
		highlightAndTagAnyFieldsAssociatedWithRequirementsNode(requirementsXmlNode, form);
	});
}

function highlightAndTagAnyFieldsAssociatedWithRequirementsNode(
	requirementsXmlNode: Element,
	form: JQuery
) {
	const labelType = $('Label Type', requirementsXmlNode).text(); // label type already validated elsewhere
	$('HighlightFields CredentialID', requirementsXmlNode).each(function (this: Element) {
		const credentialId = $(this).text();

		const associatedInput = findInputForCredentialId(credentialId, form);
		tagInput(associatedInput);
		const associatedLabel = findLabelForInput(associatedInput);
		highlightLabel(associatedLabel, labelType);
	});
}

function findInputForCredentialId(credentialId: string, form: JQuery) {
	// Protect against syntax failure if credentialId is empty
	return !!credentialId ? $(form).find('#' + credentialId) : $();
}

function tagInput(associatedInput: JQuery) {
	associatedInput.addClass('highlightedInput');
}

function findLabelForInput(associatedInput: JQuery) {
	return $(associatedInput).closest('.field').find('label');
}

function highlightLabel(associatedLabel: JQuery, labelType: string) {
	associatedLabel.addClass('highlightedField' + labelType); // note label type is validated elsewhere
	associatedLabel.text('*' + associatedLabel.text());
}
